import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from '../../../elementals/icon';
import ListingBadge, { BADGE_MODE, BADGE_ORDER_PRIORITY } from './base';
class RemoteBidBadge extends ListingBadge {
    static title = 'Remote Bid';
    static summary = '';
    static titleIcon = (_jsxs(Icon.Group, { children: [_jsx(Icon, { name: 'mobile-android', iconStyle: 'light', size: 'large' }), _jsx(Icon, { name: 'gavel', style: {
                    fontSize: '1em',
                    top: '17%',
                    left: '12%',
                    transform: 'scaleX(-1)',
                    textShadow: '-1px -1px 0px white, 1px 1px 0px white',
                } })] }));
    static content = null;
    static renderPriority = BADGE_ORDER_PRIORITY.FIRST;
    static shouldBeIncluded(listing, badgeMode) {
        const { is_remote_bid_enabled, is_remote_before_and_during_auction_enabled, } = listing.listing_summary || {};
        const remoteBidEnabled = is_remote_bid_enabled || is_remote_before_and_during_auction_enabled;
        return badgeMode === BADGE_MODE.CONDENSED && remoteBidEnabled;
    }
}
export default RemoteBidBadge;
//# sourceMappingURL=remoteBid.js.map